import { STATIC_VALUES_GET } from '../actions/types';

export const initialState = {
  userTitles: [],
  countries: [],
  documentTypes: [],
  accountTypes: [],
  riskAppetiteProfiles: [],
  riskProfiles: [],
  randomWeights: [],
  instrumentsIndex: [],
  mandateTypes: [],
  crmOwners: [],
  feeStructures: [],
  maxDrawdownScenarios: [],
  amlProfilesProperties: {},
};

export const statics = (state = initialState, action) => {
  switch (action.type) {
    case STATIC_VALUES_GET._SUCCESS: {
      const { data, valueName } = action.payload;
      state[valueName] = data;
      return state;
    }
    default:
      return state;
  }
};
